import { useTranslation } from 'react-i18next'

import { Trans } from '@/components'
import { Dropdown } from '@/components/base'
import { MachineType } from '@/consts/machine'

interface WorkloadTypeSelectorProps {
  value: (string | number)[]
  onChange: (value: (string | number)[]) => void
}

export function WorkloadTypeSelector({ value, onChange }: WorkloadTypeSelectorProps) {
  const { t } = useTranslation()

  const workloadOptions = [
    { label: t('create.typeLabelTrainingGPU'), value: MachineType.TRAINING_GPU },
    { label: t('create.typeLabelInferenceGPU'), value: MachineType.INFERENCE_GPU },
    { label: t('create.typeLabelRenderingGPU'), value: MachineType.RENDER_GPU },
  ]
  return (
    <section
      className="flex flex-col gap-2"
      data-ai-component="workload-type-filter"
      data-ai-action="select-workload-type"
      data-ai-value={value.join(',')}
    >
      <div className="text-secondary t-sb" id="workload-type-label">
        <Trans i18nKey="create.workloadTypeLabel">Workload Type</Trans>
      </div>
      <Dropdown
        multiple
        showAllOption
        options={workloadOptions}
        value={value}
        onChange={(values) => onChange(values as (string | number)[])}
        placeholder="Select workload types"
        rootClassName="w-[180px]"
      />
    </section>
  )
}
